exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".shop .shop-ctas[data-v-283a5b4b] {\n  padding: 1em 0;\n}\n.shop .cta-wrap[data-v-283a5b4b] {\n  padding: 0.5em 2%;\n}\n.shop .cta-wrap .cta-text-wrap[data-v-283a5b4b] {\n  padding-top: 0.5em;\n  min-height: 5em;\n}\n@media only screen and (max-width: 759px) {\n.shop .shop-ctas[data-v-283a5b4b] {\n    width: 104%;\n    margin: 0 -2%;\n}\n}\n@media only screen and (min-width: 760px) and (max-width: 959px) {\n.shop .shop-ctas[data-v-283a5b4b] {\n    padding: 1em 5%;\n}\n}\n", ""]);

// exports
